import SigliveServiceV1 from 'Service/sigliveServiceV1';

const patchRuleset = async ({ payload, id }) => {
  const { data } = await SigliveServiceV1({ method: 'PATCH', url: `/schedule-ruleset/${id}`, data: payload });

  return data?.data;
};

export default patchRuleset;
